import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'
import axios from 'axios'

@Module({ namespaced: true, name: 'root' })
export default class ModuleRoot extends VuexModule {
    
    fab = {
        icon: 'add',
        show: true
    }

    alert = {
        component: '',
        show: false,
        title: '',
        text: '',
        progress: 0,
        total: 0,
        current: 0,
        data: {},
        destination: ''
    }

    cancelToken: any = ''
    cancelSource: any = ''

    @Mutation
    createCancelToken() {
        this.cancelToken = axios.CancelToken
        this.cancelSource = this.cancelToken.source()
    }

    @Action
    cancel() {
        this.cancelSource.cancel('Cancelled')
    }

    @Mutation
    showFab() {
        this.fab.show = true
    }

    @Mutation
    hideFab() {
        this.fab.show = false
    }

    @Mutation
    showAlert(payload: any) {
        this.alert.component = payload.component
        this.alert.show = true
        this.alert.title = payload.title
        this.alert.text = payload.text
        this.alert.progress = payload.progress
        this.alert.total = payload.total
        this.alert.current = payload.current
        this.alert.data = payload.data
        this.alert.destination = payload.destination
    }

    @Mutation
    hideAlert() {
        this.alert.component = ''
        this.alert.show = false
        this.alert.title = ''
        this.alert.text = ''
        this.alert.progress = 0
        this.alert.total = 0
        this.alert.current = 0
        this.alert.data = {}
        this.alert.destination = ''
    }

    @Action({ commit: 'showAlert' })
    noConnectionAlert() {
        return {
            component: 'snackbar',
            text: 'Check your data or wifi connection.'
        }
    }

    @Action({ commit: 'showAlert' })
    syncSuccessAlert() {
        return {
            component: 'DialogSyncConfirm',
            title: 'Sync success',
            text: 'Your surveys are synced.'
        }
    }

    @Action({ commit: 'showAlert' })
    errorAlert() {
        return {
            component: 'dialogConfirm',
            title: 'An error occurred',
            text: 'Please try again'
        }
    }

    @Action({ commit: 'showAlert' })
    loadingAlert(title: string) {
        return {
            component: 'dialogLoading',
            title: title
        }
    }

    @Action({ commit: 'showAlert' })
    progressAlert(payload: any) {
        return {
            component: 'dialogProgress',
            title: payload.title,
            text: payload.text,
            progress: payload.progress,
            total: payload.total,
            current: payload.current
        }
    }

    @Action({ commit: 'showAlert' })
    actionAlert(payload: any) {
        return {
            component: 'dialogAction',
            title: payload.title,
            text: payload.text,
            destination: payload.destination
        }
    }

    @Action({ commit: 'showAlert' })
    snackbar(text: string) {
        return {
            component: 'snackbar',
            text: text
        }
    }

    @Action({ commit: 'showAlert' })
    confirmAlert(payload: any) {
        return {
            component: 'dialogConfirm',
            title: payload.title,
            text: payload.text
        }
    }

    @Action({ commit: 'showAlert' })
    infoAlert(payload: any) {
        return {
            component: 'dialogInfo',
            data: payload
        }
    }
}